import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { MenuTabsWrap } from 'pages/menu/components/menu-tabs';
import { MainMenuPage } from 'pages/menu/main-menu-page';
import { MainMenuPageV2 } from 'pages/menu/main-menu-page-v2';
import { useStoreRequired } from 'state/store/hooks/use-store-required';

export default function MenuScreen() {
  useStoreRequired();

  const enableUnifiedMenu = useEnableUnifiedMenu();

  return <MenuTabsWrap>{enableUnifiedMenu ? <MainMenuPageV2 /> : <MainMenuPage />}</MenuTabsWrap>;
}
